// extracted by mini-css-extract-plugin
export default {"primaryColor":"#0597ff","primaryColorWithAlpha":"rgba(247,93,190,.1019607843)","mainBgColor":"#f8f9fd","secondBgColor":"#232323"};